import React from 'react';
import { isEmpty } from 'lodash';

import ClampedText from '../ClampedText';
import LabelledText from '../LabelledText';
import { TEXTS } from '../texts';

interface RejectionReasonProps {
  /** The note the thing was rejected with, where there is one. */
  reason: string | null;
  /** What the note is called, where it is not a rejection's. */
  label?: string;
}

/**
 * The note a thing was rejected with, under a label that says what it is. The card names who
 * rejected it elsewhere — in its state chip, or in the line a log question closes on — so the note
 * is not quoted under their name. A rejection with no note shows nothing, label included. The note
 * is clamped in both panes, since a handler can write a long one.
 */
const RejectionReason: React.FC<RejectionReasonProps> = ({ reason, label = TEXTS.REJECTION_REASON }) => {
  const note = reason?.trim() ?? '';
  if (isEmpty(note)) return null;

  return (
    <LabelledText label={label}>
      <ClampedText>{note}</ClampedText>
    </LabelledText>
  );
};

export default RejectionReason;
